import { isOutOfService } from "_helperFunctions/isOutOfService";
import { isStale } from "_helperFunctions/isStale";
import { batteryCritical } from "_helperFunctions/batteryCritical";
import { hasFaults } from "_helperFunctions/hasFaults";

export const isCritical = function (car, siteSettingsData) {
    return siteSettingsData.GuardianCapable && !isOutOfService(car) && !isStale(car) && (batteryCritical(car, siteSettingsData) || hasFaults(car));
};